import script from "./designTaskPC.vue?vue&type=script&setup=true&lang=js"
export * from "./designTaskPC.vue?vue&type=script&setup=true&lang=js"

import "./designTaskPC.vue?vue&type=style&index=0&id=71539d94&lang=less&scoped=true"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71539d94"]])

export default __exports__